import {
  LOG_IN,
  LOG_OUT,
  REFRESHING_TOKEN,
  SET_SESSION,
  UPDATE_SESSION,
  SYNC_FROM_STORAGE,
} from '../extra-constants/auth';

const authInitialStates = {
  currentNavigation: 'auth',
  session: {},
  type: '',
};

function authReducer(state = authInitialStates, action) {
  const { type, payload } = action;
  const actions = {
    [LOG_IN]: () => {
      console.log('🔑 LOG_IN: User logging in', {
        timestamp: new Date().toISOString(),
      });

      return {
        ...state,
        currentNavigation: 'main',
        action: type,
      };
    },
    [LOG_OUT]: () => {
      console.log('🚪 LOG_OUT: User logging out', {
        timestamp: new Date().toISOString(),
      });

      return {
        ...state,
        currentNavigation: 'auth',
        session: {},
        action: type,
      };
    },
    [SET_SESSION]: () => ({
      ...state,
      session: {
        ...state.session,
        [payload.key]: payload.data,
      },
      action: type,
    }),
    [UPDATE_SESSION]: () => ({
      ...state,
      session: {
        ...state.session,
        user: {
          ...state.session.user,
          access_token: payload.access_token,
          refresh_token: payload.refresh_token,
        },
        expdate: payload.exp_date,
      },
      action: type,
    }),
    [REFRESHING_TOKEN]: () => ({
      ...state,
      action: type,
    }),
    [SYNC_FROM_STORAGE]: () => {
      // Sync state from localStorage when other tabs make changes
      if (typeof window !== 'undefined' && payload) {
        console.log('🔄 SYNC_FROM_STORAGE: Syncing auth state from localStorage', {
          previousState: state,
          newState: payload,
          timestamp: new Date().toISOString(),
        });

        // Ensure we preserve the complete session data from the new state
        return {
          currentNavigation: payload.currentNavigation || state.currentNavigation,
          session: payload.session || state.session,
          type: payload.type || state.type,
          action: type,
        };
      }
      return state;
    },
  };

  return actions[type] ? actions[type]() : state;
}

export { authReducer };
